export enum UserInviteRoute {
  Send = 'send',
  Complete = 'complete',
}
